import axios from "../../../axios";

export const createSchedule = async (schedule) => {
  try {
    let { name, bot_id, worker_id, execution_type, params, timezone, stop_time, stop, stop_type, cron_expression } = schedule;
    let payload = {
        name,
        bot_id,
        worker_id,
        execution_type,
        timezone,
        stop_type,
        stop,
        params,
        stop_time,
        cron_expression
    }    
    let { status } = await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/schedule`, payload);
    return status;
  } catch (err) {
    console.log("Error while uploading bot", err.message);
  }
};
